export const COPY_SHIFT = "COPY_SHIFT";
export const CLEAR_COPY = "CLEAR_COPY";

export const copyShift = (shift) => {
  return {
    type: COPY_SHIFT,
    payload: shift,
  };
};

export const clearCopy = () => {
  return {
    type: CLEAR_COPY,
  };
};
